<template>
    <b-card>
        <b-row>
            <b-col l="8">
                <h4>Add Role</h4>  
            </b-col>
            <b-col l="4">
                <b-button class="float-right" variant="secondary"  @click="cancel()"><i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Back</b-button>        
            </b-col>
        </b-row>
        <b-form>
            <b-form-group
                id="fieldset-name"
                label="Name"
                label-for="input-name"
            >
                <b-form-input
                    id="input-name"
                    v-model="model.name"
                    trim
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="fieldset-permissions"
                label="Permissions"
                label-for="input-permissions"
            >
                <permission-groups
                    v-model="model.permissions"
                ></permission-groups>
            </b-form-group>
            <b-row>
                <b-col>
                    <b-button
                        @click="cancel()"
                        variant="secondary"
                        class="float-right"
                        :disabled="submitting ? true : false"
                        >Cancel</b-button
                    >

                    <b-button
                        v-if="hasPermissionCreate"
                        @click="create()"
                        variant="primary"
                        class="float-right"
                        :disabled="submitting ? true : false"
                        >{{
                            submitting ? 'Creating Role...' : 'Create Role'
                        }}</b-button
                    >
                </b-col>
            </b-row>
        </b-form>
    </b-card>
</template>

<script>
import PermissionGroups from '@/components/PermissionGroups'
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'roles-createForm',
    mixins: [permissionsMixins, popupMixins],
    components: { PermissionGroups },
    props: [],
    data: () => {
        return {
            model: {
                name: '',
            },
            submitting: false,
            hasErrors: false,
        }
    },
    computed: {},
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        create() {
            const model = { ...this.model }
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.submitting = true
                    this.$store
                        .dispatch('roles/create', this.model)
                        .then(() => {
                            this.$emit('success', 'Created')
                        })
                        .catch(resp => {
                            const error = resp.response.data.error.message
                            this.$emit('error', error, model.name)
                        })
                        .finally(() => {
                            this.submitting = false
                        })
                }
            })
        },
    },
    mounted: function () {
        this.$store.dispatch('permissions/all')
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
